<template>
  <div>
    <span class="crumb"> <NuxtLink to="/">Home</NuxtLink> / My Account </span>
    <div class="container mt-2 pb-6">
      <div class="grid grid-cols-2 md:grid-cols-3 gap-4 justity-between">
        <div class="col-span-2 md:col-span-1">
          <h2 class="text-center md:text-left">Welcome</h2>
          <h1 class="text-center md:text-left">{{ fname }}!</h1>
          <!-- <h3 class="hidden md:block memberSince pt-3">Member since 
            <span v-if="member_since">{{ member_since | formatDate }}</span>
            <span v-else>{{ new Date().getFullYear() }}</span>
          </h3> -->
        </div>
        <div class=" mx-auto md:ml-0">
          <p class="mx-2">
            Your Address:
            <br/>
            <strong>{{ addressDisplay }}</strong>
          </p>
        </div>
        <div class="text-right">
          <p class="mx-2">
            Account Number:
            <br/>
            <strong>{{ customer_id }}</strong>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="ts">

import moment from 'moment'

export default {
  // filters: {
  //   formatDate(date) {
  //     if (date) {
  //       return moment(String(date)).format('MM/DD/YYYY');
  //     } else {
  //       return '';
  //     }
  //   }
  // },
  props: {
    fname: {
      type: String
    },
    member_since: {
      type: Date
    },
    address: {
      type: String
    },
    addressFull: {
      type: String
    },
    city: {
      type: String
    },
    state: {
      type: String
    },
    zip: {
      type: String
    },
    customer_id: {
      type: Number
    }
  },
  computed: {
    addressDisplay() {
      if (this.addressFull) {
        return this.addressFull;
      }

      const address = this.address ?? "";
      const city = this.city ?? "";
      const state = this.state ?? "";
      const zip = this.zip ?? "";

      return [address, city, state, zip].filter((component) => !!component).join(", ");
    }
  },
};
</script>

<style scoped>
h1 {
  font-size: 30px;
  line-height: 1px;
  color: #00810e;
}

h2 {
  color: #00810e;
}
h3 {
  font-weight: 500;
}
</style>
